<template>
  <home />
</template>

<script>
import home from '../components/Home'

export default {
  name: 'Home',

  components: {
    home
  }
}
</script>
